module.exports = __webpack_public_path__ + "img/a7bf5c00aee077c27955b4e48693a7e7.png";